import { render, staticRenderFns } from "./UpdatePayment.vue?vue&type=template&id=3f89ead0&"
import script from "./UpdatePayment.vue?vue&type=script&lang=js&"
export * from "./UpdatePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports